module.exports = __webpack_public_path__ + "static/media/hebebühne_fragezeichen.e8da2e5f.jpg";